// Default topics and mantras for Karmkand Bhaskar web clone
// Audio/Video URLs will be added by user via settings

export const DEFAULT_TOPICS = [
  {
    id: 'daily-sandhya',
    title: 'दैनिक संध्या',
    subtitle: 'Daily Sandhya',
    icon: 'Sun',
    color: 'from-orange-400 to-amber-500',
    mantras: [
      { id: 'm-s1', name: 'आचमन मन्त्र', text: 'ॐ अमृतोपस्तरणमसि स्वाहा।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s2', name: 'इन्द्रिय स्पर्श', text: 'ॐ वाङ् म आस्येऽस्तु। ॐ नसोर्मे प्राणोऽस्तु। ॐ अक्ष्णोर्मे चक्षुरस्तु।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s3', name: 'मार्जन मन्त्र', text: 'ॐ भूः पुनातु शिरसि। ॐ भुवः पुनातु नेत्रयोः।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s4', name: 'प्राणायाम', text: 'ॐ भूः। ॐ भुवः। ॐ स्वः। ॐ महः। ॐ जनः। ॐ तपः। ॐ सत्यम्।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s5', name: 'अघमर्षण मन्त्र', text: 'ॐ ऋतञ्च सत्यञ्चाभीद्धात्तपसोऽध्यजायत।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s6', name: 'गायत्री मन्त्र', text: 'ॐ भूर्भुवः स्वः। तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि। धियो यो नः प्रचोदयात्।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-s7', name: 'नमस्कार मन्त्र', text: 'ॐ नमः प्राच्यै दिशे यश्च देवा एतस्यां प्रतिवसन्त्येतेभ्यश्च नमो नमः।', audioUrl: '', videoUrl: '', duration: 0 }
    ]
  },
  {
    id: 'daily-yagya',
    title: 'दैनिक यज्ञ प्रक्रिया',
    subtitle: 'Daily Yagya Procedure',
    icon: 'Flame',
    color: 'from-red-500 to-orange-600',
    allowSanskar: true,
    mantras: [
      { id: 'm-y1', name: 'अग्न्याधान', text: 'ॐ भूर्भुवः स्वः द्यौरिव भूम्ना पृथिवीव वरिम्णा।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-y2', name: 'समिदाधान', text: 'ॐ अयन्त इध्म आत्मा जातवेदस्तेनेध्यस्व वर्धस्व चेद्ध वर्धय चास्मान्।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-y3', name: 'जल प्रसेचन', text: 'ॐ अदितेऽनुमन्यस्व। ॐ अनुमतेऽनुमन्यस्व। ॐ सरस्वत्यनुमन्यस्व। ॐ देव सवितः प्रसुव।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-y4', name: 'आघार आहुति', text: 'ॐ अग्नये स्वाहा। इदमग्नये इदन्न मम।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-y5', name: 'आज्य आहुति', text: 'ॐ प्रजापतये स्वाहा। इदं प्रजापतये इदन्न मम।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'm-y6', name: 'गायत्री आहुति', text: 'ॐ भूर्भुवः स्वः तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि धियो यो नः प्रचोदयात् स्वाहा।', audioUrl: '', videoUrl: '', duration: 0, isGayatriAhuti: true },
      { id: 'm-y7', name: 'पूर्णाहुति', text: 'ॐ सर्वं वै पूर्णं स्वाहा।', audioUrl: '', videoUrl: '', duration: 0 }
    ]
  },
  {
    id: 'sanskars',
    title: 'संस्कार',
    subtitle: 'Sanskaras',
    icon: 'Sparkles',
    color: 'from-pink-500 to-rose-600',
    isSanskarList: true,
    sanskarGroups: [
      { id: 'sk-punsavan', name: 'पुंसवन संस्कार' },
      { id: 'sk-namkaran', name: 'नामकरण संस्कार' },
      { id: 'sk-annaprashan', name: 'अन्नप्राशन संस्कार' },
      { id: 'sk-mundan', name: 'मुण्डन (चूड़ाकर्म) संस्कार' },
      { id: 'sk-vidyarambh', name: 'विद्यारम्भ संस्कार' },
      { id: 'sk-yagyopavit', name: 'यज्ञोपवीत-दीक्षा संस्कार' },
      { id: 'sk-vivah', name: 'विवाह संस्कार' },
      { id: 'sk-vanprasth', name: 'वानप्रस्थ संस्कार' },
      { id: 'sk-antyeshti', name: 'अन्त्येष्टि-अस्थि विसर्जन संस्कार' },
      { id: 'sk-marnottar', name: 'मरणोत्तर संस्कार (श्राद्ध तर्पण)' },
      { id: 'sk-janmdivas', name: 'जन्म दिवस संस्कार' },
      { id: 'sk-vivahdivas', name: 'विवाह दिवस संस्कार' },
    ],
    mantras: [
      // पुंसवन (3 mantras)
      { id: 'sk-punsavan-1', sanskarGroup: 'sk-punsavan', name: 'पुंसवन - मन्त्र 1', text: 'ॐ सुपर्णोऽसि गरुत्मान् त्रिवृत्ते शिरो गायत्रं चक्षुः। बृहद्रथन्तरे पक्षौ स्तोम आत्मा छन्दांस्यङ्गानि।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-punsavan-2', sanskarGroup: 'sk-punsavan', name: 'पुंसवन - मन्त्र 2', text: 'ॐ विष्णुर्योनिं कल्पयतु त्वष्टा रूपाणि पिंशतु। आ सिञ्चतु प्रजापतिर्धाता गर्भं दधातु ते।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-punsavan-3', sanskarGroup: 'sk-punsavan', name: 'पुंसवन - मन्त्र 3', text: 'ॐ धाता ददातु दाशुषे प्राचीं जीवातुमक्षिताम्। वयं देवस्य धीमहि सुमतिं सत्यराधसः।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // नामकरण (2 mantras)
      { id: 'sk-namkaran-1', sanskarGroup: 'sk-namkaran', name: 'नामकरण - मन्त्र 1', text: 'ॐ अङ्गिरसामायनेऽसि सर्वेषां प्रियो भूयासम् तेजस्वी मेधावी।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-namkaran-2', sanskarGroup: 'sk-namkaran', name: 'नामकरण - मन्त्र 2', text: 'ॐ अङ्गादङ्गात् सम्भवसि हृदयादधिजायसे। आत्मा वै पुत्रनामासि स जीव शरदः शतम्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // अन्नप्राशन (2 mantras)
      { id: 'sk-annaprashan-1', sanskarGroup: 'sk-annaprashan', name: 'अन्नप्राशन - मन्त्र 1', text: 'ॐ अन्नपतेऽन्नस्य नो देह्यनमीवस्य शुष्मिणः। प्रप्रदातारं तारिषा ऊर्जं नो धेहि द्विपदे चतुष्पदे।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-annaprashan-2', sanskarGroup: 'sk-annaprashan', name: 'अन्नप्राशन - मन्त्र 2', text: 'ॐ शं नो भवन्त्वायुषे शं नो भवन्तु पीतये। शं यो रोगेभ्यो यच्छन्तु शं ते सन्तु जिजीविषे।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // मुण्डन / चूड़ाकर्म (2 mantras)
      { id: 'sk-mundan-1', sanskarGroup: 'sk-mundan', name: 'मुण्डन - मन्त्र 1', text: 'ॐ शिवो नामासि स्वधितिस्ते पिता नमस्ते अस्तु मा मा हिंसीः।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-mundan-2', sanskarGroup: 'sk-mundan', name: 'मुण्डन - मन्त्र 2', text: 'ॐ येनावपत् सविता क्षुरेण सोमस्य राज्ञो वरुणस्य विद्वान्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // विद्यारम्भ (2 mantras)
      { id: 'sk-vidyarambh-1', sanskarGroup: 'sk-vidyarambh', name: 'विद्यारम्भ - मन्त्र 1', text: 'ॐ सरस्वति नमस्तुभ्यं वरदे कामरूपिणि। विद्यारम्भं करिष्यामि सिद्धिर्भवतु मे सदा।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-vidyarambh-2', sanskarGroup: 'sk-vidyarambh', name: 'विद्यारम्भ - मन्त्र 2', text: 'ॐ अग्ने व्रतपते व्रतं चरिष्यामि तच्छकेयं तन्मे राध्यताम्। इदमहमनृतात् सत्यमुपैमि।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // यज्ञोपवीत (3 mantras)
      { id: 'sk-yagyopavit-1', sanskarGroup: 'sk-yagyopavit', name: 'यज्ञोपवीत - मन्त्र 1', text: 'ॐ यज्ञोपवीतं परमं पवित्रं प्रजापतेर्यत्सहजं पुरस्तात्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-yagyopavit-2', sanskarGroup: 'sk-yagyopavit', name: 'यज्ञोपवीत - मन्त्र 2', text: 'ॐ युवा सुवासाः परिवीत आगात् स उ श्रेयान् भवति जायमानः।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-yagyopavit-3', sanskarGroup: 'sk-yagyopavit', name: 'यज्ञोपवीत - मन्त्र 3', text: 'ॐ आयुष्यं वर्चस्यं रायस्पोषमौद्भिदम्। इदं हिरण्यवर्चस्वज्जैत्रायाविशतादु माम्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // विवाह (2 mantras)
      { id: 'sk-vivah-1', sanskarGroup: 'sk-vivah', name: 'विवाह - मन्त्र 1', text: 'ॐ गृभ्णामि ते सौभगत्वाय हस्तं मया पत्या जरदष्टिर्यथासः।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-vivah-2', sanskarGroup: 'sk-vivah', name: 'विवाह - मन्त्र 2', text: 'ॐ धर्मे च अर्थे च कामे च नातिचरामि। मम व्रतसंकल्पं प्रति प्रतिज्ञां करोमि।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // वानप्रस्थ (2 mantras)
      { id: 'sk-vanprasth-1', sanskarGroup: 'sk-vanprasth', name: 'वानप्रस्थ - मन्त्र 1', text: 'ॐ संगच्छध्वं संवदध्वं सं वो मनांसि जानताम्। देवा भागं यथा पूर्वे संजानाना उपासते।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-vanprasth-2', sanskarGroup: 'sk-vanprasth', name: 'वानप्रस्थ - मन्त्र 2', text: 'ॐ कृण्वन्तो विश्वमार्यं तेजस्विनामधीतमस्तु। सहनाववतु सहनौ भुनक्तु।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // अन्त्येष्टि (2 mantras)
      { id: 'sk-antyeshti-1', sanskarGroup: 'sk-antyeshti', name: 'अन्त्येष्टि - मन्त्र 1', text: 'ॐ कृष्णं नियानं हरयः सुपर्णा अपो वसाना दिवमुत्पतन्ति।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-antyeshti-2', sanskarGroup: 'sk-antyeshti', name: 'अस्थि विसर्जन', text: 'ॐ या ते रुद्र शिवा तनूः शिवा विश्वाहभेषजी। शिवा रुद्रस्य भेषजी तया नो मृड जीवसे।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // मरणोत्तर / श्राद्ध तर्पण (2 mantras)
      { id: 'sk-marnottar-1', sanskarGroup: 'sk-marnottar', name: 'श्राद्ध तर्पण - मन्त्र 1', text: 'ॐ पितृभ्यः स्वधायिभ्यः स्वधा नमः पितामहेभ्यः स्वधायिभ्यः स्वधा नमः।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-marnottar-2', sanskarGroup: 'sk-marnottar', name: 'श्राद्ध तर्पण - मन्त्र 2', text: 'ॐ प्रजापत्यं तीर्थं ब्रह्मणं तीर्थं देवं तीर्थम् पितृणां तीर्थम्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // जन्म दिवस (2 mantras)
      { id: 'sk-janmdivas-1', sanskarGroup: 'sk-janmdivas', name: 'जन्म दिवस - मन्त्र 1', text: 'ॐ शतायुर्वै पुरुषः शतेन्द्रियः। आयुष्येवेन्द्रिये प्रतितिष्ठति।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-janmdivas-2', sanskarGroup: 'sk-janmdivas', name: 'जन्म दिवस - मन्त्र 2', text: 'ॐ तच्चक्षुर्देवहितं पुरस्ताच्छुक्रमुच्चरत्। पश्येम शरदः शतम् जीवेम शरदः शतम्।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },

      // विवाह दिवस (2 mantras)
      { id: 'sk-vivahdivas-1', sanskarGroup: 'sk-vivahdivas', name: 'विवाह दिवस - मन्त्र 1', text: 'ॐ समञ्जन्तु विश्वे देवाः समापो हृदयानि नौ। सं मातरिश्वा सं धाता समु देष्ट्री दधातु नौ।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
      { id: 'sk-vivahdivas-2', sanskarGroup: 'sk-vivahdivas', name: 'विवाह दिवस - मन्त्र 2', text: 'ॐ सहनाववतु सह नौ भुनक्तु सहवीर्यं करवावहै। तेजस्विनावधीतमस्तु मा विद्विषावहै।', audioUrl: '', videoUrl: '', insertAfterYagyaId: 'm-y6' },
    ]
  },
  {
    id: 'havan-mantras',
    title: 'विशेष हवन मन्त्र',
    subtitle: 'Special Havan Mantras',
    icon: 'Flame',
    color: 'from-amber-500 to-yellow-600',
    mantras: [
      { id: 'hv-1', name: 'महामृत्युञ्जय मन्त्र', text: 'ॐ त्र्यम्बकं यजामहे सुगन्धिं पुष्टिवर्धनम्। उर्वारुकमिव बन्धनान्मृत्योर्मुक्षीय मामृतात्।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'hv-2', name: 'शान्ति पाठ', text: 'ॐ द्यौः शान्तिरन्तरिक्षं शान्तिः पृथिवी शान्तिरापः शान्तिरोषधयः शान्तिः।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'hv-3', name: 'स्वस्तिवाचन', text: 'ॐ स्वस्ति न इन्द्रो वृद्धश्रवाः स्वस्ति नः पूषा विश्ववेदाः।', audioUrl: '', videoUrl: '', duration: 0 }
    ]
  },
  {
    id: 'aarti',
    title: 'आरती संग्रह',
    subtitle: 'Aarti Collection',
    icon: 'Lamp',
    color: 'from-yellow-500 to-orange-500',
    mantras: [
      { id: 'ar-1', name: 'ॐ जय जगदीश हरे', text: 'ॐ जय जगदीश हरे, स्वामी जय जगदीश हरे। भक्त जनों के संकट क्षण में दूर करे।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'ar-2', name: 'गायत्री आरती', text: 'जयति जय गायत्री माता। जयति जय गायत्री माता।', audioUrl: '', videoUrl: '', duration: 0 }
    ]
  },
  {
    id: 'bhajan',
    title: 'भजन',
    subtitle: 'Bhajans',
    icon: 'Music',
    color: 'from-purple-400 to-pink-500',
    mantras: [
      { id: 'bh-1', name: 'वैष्णव जन तो', text: 'वैष्णव जन तो तेने कहिए जे पीड़ पराई जाणे रे।', audioUrl: '', videoUrl: '', duration: 0 },
      { id: 'bh-2', name: 'रघुपति राघव', text: 'रघुपति राघव राजा राम, पतित पावन सीताराम।', audioUrl: '', videoUrl: '', duration: 0 }
    ]
  }
];

export const APP_INFO = {
  name: 'कर्मकाण्ड भास्कर',
  subtitle: 'Karmkand Bhaskar',
  tagline: 'वैदिक मन्त्र एवं संस्कार संग्रह'
};
